import styled from 'styled-components';
import { Divider, Typography, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { FilterAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Chip from '../Chip/Chip';

interface Props {
  disabled?: boolean;
  filters?: ReactNode;
  activeFilters?: ReactNode;
  resetActiveFilters?: () => void;
}

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};
  background-color: ${(props) =>
    props.theme.palette.mode === 'light'
      ? props.theme.palette.background.paper
      : 'rgba(255, 255, 255, 0.1)'};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  & hr {
    margin-left: -${(props) => props.theme.spacing(2)};
    margin-right: -${(props) => props.theme.spacing(2)};
  }
`;

const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
`;

const ActiveFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${(props) => props.theme.spacing(1)} 0;
`;

const Filter: FC<Props> = ({ disabled, filters, activeFilters, resetActiveFilters }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <FilterContainer>
      <FilterHeader>
        <FilterAlt sx={{ mr: theme.spacing(1) }} />
        <Typography variant="h6">{t('filter_heading')}</Typography>
      </FilterHeader>
      <Divider />
      {filters}
      <Divider sx={{ mt: theme.spacing(1) }} />
      <ActiveFilter>
        <Chip
          disabled={disabled}
          label={t('reset')}
          variant="outlined"
          color="error"
          onClick={resetActiveFilters}
        />
        {activeFilters}
      </ActiveFilter>
    </FilterContainer>
  );
};

export default Filter;
